import { gql } from '@apollo/client';

export const GET_CLASSIFICATION_GROUPS = gql`
  query GetClassificationGroups($tenantId: String) {
    getClassificationGroups(tenantId: $tenantId) {
      id
      name
      description
      version
      status
      tenantId
      classifications {
        id
        name
        description
        version
        status
        tenantId
        classificationGroupId
        classificationLevels {
          id
          name
          description
          status
          tenantId
          classificationId
          minimums {
            countryHash
            minimum
          }
        }
      }
    }
  }
`;

// Classification Level Client Rates (minimums per country hash per level)
export const CLASSIFICATION_LEVEL_CLIENT_RATE_FIELDS = gql`
  fragment ClassificationLevelClientRateFields on ClassificationLevelClientRate {
    id
    classificationLevelId
    clientId
    tenantId
    minimums {
      countryHash
      minimum
    }
  }
`;

export const GET_CLASSIFICATION_LEVEL_CLIENT_RATES = gql`
  ${CLASSIFICATION_LEVEL_CLIENT_RATE_FIELDS}
  query GetClassificationLevelClientRates($clientId: String!) {
    getClassificationLevelClientRates(clientId: $clientId) {
      ...ClassificationLevelClientRateFields
    }
  }
`;

export const SET_CLASSIFICATION_LEVEL_CLIENT_RATE = gql`
  ${CLASSIFICATION_LEVEL_CLIENT_RATE_FIELDS}
  mutation SetClassificationLevelClientRate(
    $classificationLevelId: String!
    $clientId: String!
    $minimums: [MinimumInput!]!
  ) {
    setClassificationLevelClientRate(
      classificationLevelId: $classificationLevelId
      clientId: $clientId
      minimums: $minimums
    ) {
      ...ClassificationLevelClientRateFields
    }
  }
`;
